import React from 'react';
import { Switch } from '@mui/material';
import clsx from 'clsx';
import './index.scss';

interface CustomizedSwitchProps {
  label: string;
  name: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (e: any, name: string) => void;
}

const CustomizedSwitch: React.FC<CustomizedSwitchProps> = ({
  label,
  name,
  checked,
  disabled,
  onChange,
}) => {
  return (
    <div className="d-switch">
      <Switch
        classes={{
          root: 'switch-root',
          track: clsx('switch-track', disabled && 'switch-track-disabled'),
          thumb: 'switch-thumb',
          switchBase: 'switch-base',
        }}
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={(e: any) => onChange(e, name)}
        data-testid={`switch-${name.toLowerCase()}`}
      />
      <label>{label}</label>
    </div>
  );
};

export default CustomizedSwitch;
